<div class="panel"
  [style.width.px]="width"
  [style.height.px]="height"
  [@toggleTooltip]="{ value: animationState, params: { height: height } }"
  (@toggleTooltip.done)="onToggleTooltip($event)"
  (clickOutside)="onClickOutside()">
  <div [style.width.px]="width - 7"
    [style.height.px]="height - 7">
    <div itemSize="35"
      class="aa-scrollable-y aa-scrollbar"
      [style.width.%]="100"
      [style.height.%]="100">
      @for (item of data; track item; let idx = $index) {
        <aa-item-popup-dropdown
          [labelKey]="parameters.labelKey"
          [item]="item"
          (selectedItem)="onSelectedItem($event)">
        </aa-item-popup-dropdown>
      }
    </div>
  </div>
</div>
